import { Link, useRouterState } from "@tanstack/react-router";
import { useState } from "react";
import { Search, Menu, X, Phone } from "lucide-react";
import logo from "@/assets/logo.png";
import { CartDrawer } from "./CartDrawer";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const navItems = [
  { to: "/", label: "Home" },
  { to: "/shop", label: "Shop" },
  { to: "/about", label: "About" },
  { to: "/testimonials", label: "Reviews" },
  { to: "/contact", label: "Contact" },
];

export function Header() {
  const [open, setOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [query, setQuery] = useState("");
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  return (
    <header className="sticky top-0 z-50 w-full bg-background text-foreground border-b border-border shadow-soft">
      {/* announcement bar */}
      <div className="bg-[--navy] text-white text-xs sm:text-sm py-2 px-4 text-center font-medium">
        🚚 Free Cash on Delivery All Over Pakistan • Trusted by Hundreds of Customers
      </div>

      <div className="container mx-auto px-4 flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-3 shrink-0">
          <img src={logo} alt="Trendora Marts logo" width={48} height={48} className="h-12 w-12 object-contain" />
          <div className="hidden sm:flex flex-col leading-tight">
            <span className="font-serif text-lg font-semibold text-[--navy]">Trendora Marts</span>
            <span className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Smart Shopping</span>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`text-sm uppercase tracking-wider gold-underline transition-colors ${
                pathname === item.to ? "text-[--teal]" : "text-foreground hover:text-[--teal]"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-1 sm:gap-2">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setSearchOpen((s) => !s)}
            aria-label="Search"
          >
            <Search className="h-5 w-5" />
          </Button>
          <CartDrawer />
          <Button
            variant="ghost"
            size="icon"
            className="lg:hidden"
            onClick={() => setOpen((s) => !s)}
            aria-label="Menu"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </Button>
        </div>
      </div>

      {searchOpen && (
        <div className="border-t border-border bg-secondary px-4 py-4 animate-fade-in">
          <form
            className="container mx-auto flex gap-2"
            onSubmit={(e) => {
              e.preventDefault();
              window.location.href = `/shop?q=${encodeURIComponent(query)}`;
            }}
          >
            <Input
              autoFocus
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search products..."
              className="bg-background"
            />
            <Button type="submit" variant="teal">Search</Button>
          </form>
        </div>
      )}

      {open && (
        <nav className="lg:hidden border-t border-border bg-background animate-fade-in">
          <div className="container mx-auto px-4 py-4 flex flex-col gap-3">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className={`text-sm uppercase tracking-wider py-2 ${
                  pathname === item.to ? "text-[--teal]" : "text-foreground"
                }`}
              >
                {item.label}
              </Link>
            ))}
            <a href="tel:03707851120" className="flex items-center gap-2 text-[--teal] text-sm pt-2 border-t border-border">
              <Phone className="h-4 w-4" /> 0370-7851120
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}
